import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {BehaviorSubject, Observable} from "rxjs";
import {Conseil} from "../models/conseil";
import {filter, switchMap} from "rxjs/operators";
import {Deserialize} from "cerialize";
import { HttpClient } from "@angular/common/http";
import {Contact} from "../models/contact";
import {Consumption} from "../models/consumption";
import {Logement} from "../models/logement";

@Injectable({
  providedIn: 'root'
})
export class ConsumptionService {
  baseApiUrl: string = environment.api.baseUrl;

  private _consumptions: BehaviorSubject<Consumption> = new BehaviorSubject(null);
  public readonly consumptions: Observable<Consumption> = this._consumptions.asObservable().pipe(filter(consumptions => consumptions != null));

  constructor(private http: HttpClient) {
  }

  search(logementId, startDate, endDate, secondTart, energy = '' ): Observable<Consumption> {
    return this.http.get(`${this.baseApiUrl}rt2012/detail-consommation/logement/${logementId}/${startDate}/${endDate}/${secondTart}?energy=${energy}`).pipe(switchMap(data => {
        const consumption = Deserialize(data, Consumption);
        this._consumptions.next(consumption);
        return this._consumptions;
      })
    );
  }

}
